<script>
export default {
  name: 'EmptyTable',
  props: {
    columns: {
      type: Number,
      default: 4,
    },
    text: {
      type: String,
      default: '',
    },
  },
  data() {
    return {};
  },
};
</script>

<template>
  <tbody>
    <tr>
      <td :colspan="$props.columns">
        <div class="empty-table">
          <div class="empty-table__text">
            {{
              $props.text
                ? $props.text
                : `There is nothing to see here at the moment`
            }}
          </div>
        </div>
      </td>
    </tr>
  </tbody>
</template>

<style scoped lang="scss">
@import '@/styles/variables.scss';
.empty-table {
  min-height: 239px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 10px 20px;
  background-image: url('~@/assets/png/leaderboard-empty.png');

  &__text {
    font-family: Poppins-Regular;
    font-size: 18px;
    line-height: 1.5;
    color: #ffffff;
    max-width: 422px;
  }
}

@media (max-width: $mobile) {
  .empty-table {
    min-height: 200px;
    padding: 10px 15px;

    &__text {
      font-size: 14px;
    }
  }
}
</style>
